import * as React from "react";
import { IKnowledgeBaseArticle } from "../api/knowledgeBase";

type SelectArticle = (
  articleId: number | null,
  options?: { fromHash?: boolean }
) => void;

export function useArticleSelection(
  allArticles: IKnowledgeBaseArticle[] | undefined,
  selectArticle: SelectArticle
) {
  const [pendingSelectionId, setPendingSelectionId] =
    React.useState<number | null>(null);
  const [pendingExpandIds, setPendingExpandIds] = React.useState<
    Array<string | number>
  >([]);

  React.useEffect(() => {
    if (
      pendingSelectionId === null ||
      !allArticles?.some((article) => article.id === pendingSelectionId)
    ) {
      return;
    }

    selectArticle(pendingSelectionId);
    setPendingSelectionId(null);
    setPendingExpandIds([]);
  }, [allArticles, pendingSelectionId, selectArticle]);

  return {
    pendingSelectionId,
    setPendingSelectionId,
    pendingExpandIds,
    setPendingExpandIds,
  };
}

